export default {
  tabs: {
    home: "Home",
    browse: "Browse",
    trends: "Trends",
    myPicks: "My Picks",
    leagues: "Leagues",
  },
  common: {
    viewAll: "View all",
    operator: "Operator",
    priceComparison: "Price Comparison",
    linematePlus: "Linemate+",
    joinLinematePlus: "Join Linemate+",
    actions: {
      apply: "Apply",
      clearAll: "Clear all",
      gotIt: "Got it",
      cancel: "Cancel",
      close: "Close",
      openSettings: "Open Settings",
      continue: "Continue",
      claim: "Claim",
      visitPartner: "Visit Partner",
      alreadyHaveAccount: "I already have an account",
      edit: "Edit",
      done: "Done",
      save: "Save",
      changePassword: "Change password",
      submit: "Submit",
      resendCode: "Resend Code",
      getStarted: "Get started",
      continueWithApple: "Continue with Apple",
      continueWithGoogle: "Continue with Google",
      continueWithEmail: "Continue with email",
      selectLocation: "Select a location",
      showMore: "Show more",
    },
    labels: {
      player: "Player",
      team: "Team",
      firstName: "First Name",
      lastName: "Last Name",
      username: "Username",
      email: "Email",
      password: "Password",
      emailAddress: "Email address",
      confirmPassword: "Confirm Password",
      code: "Code",
      preferredOdds: "Preferred odds",
    },
    placeholders: {
      emailAddress: "Enter your email address...",
      password: "Enter your password...",
    },
    errors: {
      genericTryAgainLater: "Something went wrong, please try again later.",
      noInternetConnection: "No Internet Connection",
    },
    search: {
      teamOrPlayerPlaceholder: "Search for a team or player...",
    },
    affiliate: {
      claimYourOffer: "Claim your {{operator}} offer",
    },
    advancedTools: {
      startingLineups: "Starting Lineups",
      startingPitchers: "Starting Pitchers",
      weatherReport: "Weather Report",
    },
    toasts: {
      addedToMyPicks: "Added to My Picks",
      alreadyInMyPicks: "Already in My Picks",
    },
    hints: {
      goToMyPicks: "Go to My Picks to place your bet.",
    },
    profile: {
      completeYourProfile: "Complete your profile",
    },
    bonuses: "Bonuses",
    statHeaders: {
      "+/-": "+/-",
      "1B": "1B",
      "1D": "1D",
      "1PT": "1PT",
      "20/40": "20/40",
      "2B": "2B",
      "2PT": "2PT",
      "2YELRED": "2YELRED",
      "3B": "3B",
      "3D%": "3D%",
      "3PT%": "3PT%",
      "3PTA": "3PTA",
      "3PTM": "3PTM",
      "4D%": "4D%",
      "40/20": "40/20",
      "A": "A",
      "AB": "AB",
      "AST": "AST",
      "AVG": "AVG",
      "B": "B",
      "BB": "BB",
      "BK": "BK",
      "BLK": "BLK",
      "C%": "C%",
      "CA": "CA",
      "CF%": "CF%",
      "CFK": "CFK",
      "CM": "CM",
      "COR": "COR",
      "CR%": "CR%",
      "CS": "CS",
      "D": "D",
      "DHR": "DHR",
      "DP": "DP",
      "DR": "DR",
      "DRI": "DRI",
      "DSAV": "DSAV",
      "EFG%": "EFG%",
      "ER": "ER",
      "ERA": "ERA",
      "FG": "FG",
      "FG%": "FG%",
      "FGA": "FGA",
      "FGM": "FGM",
      "FLS": "FLS",
      "FT%": "FT%",
      "FTA": "FTA",
      "FTM": "FTM",
      "FUML": "FUML",
      "G": "G",
      "GA": "GA",
      "GK": "GK",
      "GP": "GP",
      "OPP": "OPP",
      "H": "H",
      "HO": "HO",
      "HR": "HR",
      "HU": "HU",
      "INT": "INT",
      "ISO": "ISO",
      "IS": "IS",
      "K": "K",
      "KM": "KM",
      "KR": "KR",
      "KRM": "KRM",
      "L": "L",
      "LB": "LB",
      "LOP": "LOP",
      "M": "M",
      "MI50": "MI50",
      "MIN": "MIN",
      "OBP": "OBP",
      "OFF": "OFF",
      "OPS": "OPS",
      "P": "P",
      "PAS": "PAS",
      "PASS ATT": "PASS ATT",
      "PASS COMP": "PASS COMP",
      "PASS RTG": "PASS RTG",
      "PASS TD": "PASS TD",
      "PASS YDS": "PASS YDS",
      "PASS YDS/ATT": "PASS YDS/ATT",
      "PASS RZ ATT": "PASS RZ ATT",
      "PASS RZ COMPL": "PASS RZ COMPL",
      "PASS RZ TD": "PASS RZ TD",
      "PCRM": "PCRM",
      "PIM": "PIM",
      "PLAYS": "PLAYS",
      "POS": "POS",
      "POS%": "POS%",
      "PP%": "PP%",
      "PPG": "PPG",
      "PPP": "PPP",
      "PS": "PS",
      "PTS": "PTS",
      "R": "R",
      "RBI": "RBI",
      "REB": "REB",
      "REC": "REC",
      "REC TGT": "REC TGT",
      "REC TD": "REC TD",
      "REC YDS": "REC YDS",
      "REC YDS/REC": "REC YDS/REC",
      "REC 100+ YDS": "REC 100+ YDS",
      "REC RZ TGT": "REC RZ TGT",
      "REC RZ REC": "REC RZ REC",
      "REC RZ TD": "REC RZ TD",
      "RED": "RED",
      "RM": "RM",
      "RUSH ATT": "RUSH ATT",
      "RUSH LONG": "RUSH LONG",
      "RUSH TD": "RUSH TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH YDS/ATT": "RUSH YDS/ATT",
      "RUSH 100+ YDS": "RUSH 100+ YDS",
      "RUSH RZ ATT": "RUSH RZ ATT",
      "RUSH RZ TD": "RUSH RZ TD",
      "RZ%": "RZ%",
      "S": "S",
      "S%": "S%",
      "SA": "SA",
      "SAT": "SAT",
      "SAV": "SAV",
      "SAVES": "SAVES",
      "SHG": "SHG",
      "SH%": "SH%",
      "SHO": "SHO",
      "SHP": "SHP",
      "SHUTOUTS": "SHUTOUTS",
      "SK": "SK",
      "SLG": "SLG",
      "SO": "SO",
      "SOG": "SOG",
      "SOT": "SOT",
      "STL": "STL",
      "SV": "SV",
      "SV%": "SV%",
      "T": "T",
      "TA": "TA",
      "TB": "TB",
      "TCK": "TCK",
      "TD": "TD",
      "TO": "TO",
      "TOI": "TOI",
      "TRB": "TRB",
      "TS%": "TS%",
      "USAGE %": "USAGE %",
      "W": "W",
      "WHIP": "WHIP",
      "WINS": "WINS",
      "XPA": "XPA",
      "XPM": "XPM",
      "XP%": "XP%",
      "YDS": "YDS",
      "YEL": "YEL",
      "FG (0-19)": "FG (0-19)",
      "FG (20-29)": "FG (20-29)",
      "FG (30-39)": "FG (30-39)",
      "FG (40-49)": "FG (40-49)",
      "FG (50+)": "FG (50+)",
      "300+ YDS": "300+ YDS",
    },
    sportStatHeaders: {
      "soccer": {
        "team": {
          "Running performance (per match)": "Running performance (per match)",
          "Distance covered": "Distance covered",
          "Number of sprints": "Number of sprints",
          "Attacking": "Attacking",
          "Goals per game": "Goals per game",
          "Penalty goals": "Penalty goals",
          "Free kick goals": "Free kick goals",
          "Goals from inside the box": "Goals from inside the box",
          "Goals from outside the box": "Goals from outside the box",
          "Left-footed goals": "Left-footed goals",
          "Right-footed goals": "Right-footed goals",
          "Headed goals": "Headed goals",
          "Big chances per game": "Big chances per game",
          "Big chances missed per game": "Big chances missed per game",
          "Total shots per game": "Total shots per game",
          "Shots on target per game": "Shots on target per game",
          "Shots off target per game": "Shots off target per game",
          "Blocked shots per game": "Blocked shots per game",
          "Succ. dribbles per game": "Succ. dribbles per game",
          "Corners per game": "Corners per game",
          "Free kicks per game": "Free kicks per game",
          "Hit woodwork": "Hit woodwork",
          "Counter attacks": "Counter attacks",
          "Passes": "Passes",
          "Ball possession": "Ball possession",
          "Accurate passes": "Accurate passes",
          "Acc. own half": "Acc. own half",
          "Acc. opposition half": "Acc. opposition half",
          "Acc. long balls": "Acc. long balls",
          "Acc. crosses": "Acc. crosses",
          "Defending": "Defending",
          "Clean sheets": "Clean sheets",
          "Goals conceded per game": "Goals conceded per game",
          "Tackles per game": "Tackles per game",
          "Interceptions per game": "Interceptions per game",
          "Clearances per game": "Clearances per game",
          "Saves per game": "Saves per game",
          "Balls recovered per game": "Balls recovered per game",
          "Errors leading to shot": "Errors leading to shot",
          "Errors leading to goal": "Errors leading to goal",
          "Penalties committed": "Penalties committed",
          "Penalty goals conceded": "Penalty goals conceded",
          "Clearance off line": "Clearance off line",
          "Last man tackle": "Last man tackle",
          "Other": "Other",
          "Duels won per game": "Duels won per game",
          "Ground duels won": "Ground duels won",
          "Aerial duels won": "Aerial duels won",
          "Possession lost per game": "Possession lost per game",
          "Throw-ins per game": "Throw-ins per game",
          "Goal kicks per game": "Goal kicks per game",
          "Offsides per game": "Offsides per game",
          "Fouls per game": "Fouls per game",
          "Yellow cards per game": "Yellow cards per game",
          "Red cards": "Red cards"
        },
        "player": {
          "Matches": "Matches",
          "Appearances": "Appearances",
          "Started": "Started",
          "Minutes per game": "Minutes per game",
          "Total minutes played": "Total minutes played",
          "Team of the week": "Team of the week",
          "Running performance (per 90)": "Running performance (per 90)",
          "Top speed": "Top speed",
          "Goals": "Goals",
          "Expected goals (xG)": "Expected goals (xG)",
          "Scoring frequency (in minutes)": "Scoring frequency (in minutes)",
          "Total shots": "Total shots",
          "Shots on target per game": "Shots on target per game",
          "Big chances missed": "Big chances missed",
          "Goal conversion": "Goal conversion",
          "Penalty conversion": "Penalty conversion",
          "Free kick conversion": "Free kick conversion",
          "Penalty won": "Penalty won",
          "Passing": "Passing",
          "Assists": "Assists",
          "Expected assists (xA)": "Expected assists (xA)",
          "Touches": "Touches",
          "Big chances created": "Big chances created",
          "Key passes": "Key passes",
          "Long balls (accurate)": "Long balls (accurate)",
          "Accurate chip passes": "Accurate chip passes",
          "Interceptions": "Interceptions",
          "Possession won (final third)": "Possession won (final third)",
          "Dribbled past per game": "Dribbled past per game",
          "Other (per game)": "Other (per game)",
          "Succ. dribbles": "Succ. dribbles",
          "Total duels won": "Total duels won",
          "Possession lost": "Possession lost",
          "Was fouled": "Was fouled",
          "Offsides": "Offsides",
          "Cards": "Cards",
          "Yellow": "Yellow",
          "Red (2 yellows)": "Red (2 yellows)",
          "Red": "Red"
        }
      },
      "hockey": {
        "team": {
          "Game overview": "Game overview",
          "Shots on goal": "Shots on goal",
          "Penalties": "Penalties",
          "Penalty minutes": "Penalty minutes",
          "Hits": "Hits",
          "Blocked shots": "Blocked shots",
          "Takeaways": "Takeaways",
          "Giveaways": "Giveaways",
          "Empty net goals": "Empty net goals",
          "Power play %": "Power play %",
          "Faceoffs won": "Faceoffs won",
          "Game Shotmap": "Game Shotmap",
          "Select shot type in shotmap": "Select shot type in shotmap",
          "Special teams": "Special teams",
          "Power play shot %": "Power play shot %",
          "Shorthanded shot %": "Shorthanded shot %",
          "Even strength shot %": "Even strength shot %",
          "Power play faceoffs": "Power play faceoffs",
          "Shorthanded faceoffs": "Shorthanded faceoffs",
          "Even strength faceoffs": "Even strength faceoffs",
          "5v4 conversion": "5v4 conversion",
          "Shots": "Shots",
          "Wrist": "Wrist",
          "Slap": "Slap",
          "Backhand": "Backhand",
          "Tip": "Tip",
          "Snap": "Snap",
          "Advanced stats": "Advanced stats",
          "Corsi %": "Corsi %",
          "Fenwick %": "Fenwick %",
          "Average shot distance": "Average shot distance"
        },
        "player": {
          "Overall": "Overall",
          "Games played": "Games played",
          "Average time on ice": "Average time on ice",
          "Goals": "Goals",
          "Assists": "Assists",
          "Points": "Points",
          "Plus/minus": "Plus/minus",
          "Shots on goal": "Shots on goal",
          "Shooting percentage": "Shooting percentage",
          "Game winning goals": "Game winning goals",
          "Overtime goals": "Overtime goals",
          "Defensive": "Defensive",
          "Penalty minutes": "Penalty minutes",
          "Blocked shots": "Blocked shots",
          "Hits": "Hits",
          "Power play": "Power play",
          "Powerplay average time on ice": "Powerplay average time on ice",
          "Power play goals": "Power play goals",
          "Power play assists": "Power play assists",
          "Power play points": "Power play points",
          "Shorthanded": "Shorthanded",
          "Shorthanded average time on ice": "Shorthanded average time on ice",
          "Shorthanded goals": "Shorthanded goals",
          "Shorthanded assists": "Shorthanded assists",
          "Shorthanded points": "Shorthanded points",
          "Shorthanded shots": "Shorthanded shots",
          "Even-strength": "Even-strength",
          "Even strength average time on ice": "Even strength average time on ice",
          "Faceoff": "Faceoff",
          "Faceoffs taken": "Faceoffs taken",
          "Faceoffs won": "Faceoffs won",
          "Faceoff win percentage": "Faceoff win percentage"
        }
      },
      "baseball": {
        "AB": "At-bats",
        "R": "Runs",
        "H": "Hits",
        "RBI": "Runs batted in",
        "HR": "Home runs",
        "BB": "Walks",
        "K": "Strikeouts",
        "AVG": "Batting average",
        "OBP": "On-base percentage",
        "SLG": "Slugging percentage",
        "OPS": "On-base plus slugging",
        "IP": "Innings pitched",
        "ERA": "Earned run average",
        "H_ALLOWED": "Hits allowed",
        "R_ALLOWED": "Runs allowed",
        "ER": "Earned runs",
        "BB_ALLOWED": "Walks allowed",
        "HR_ALLOWED": "Home runs allowed",
        "NP": "Number of pitches",
        "STR": "Strikes thrown",
        "WHIP": "Walks and hits per innings pitched",
        "PO": "Putouts",
        "A": "Assists",
        "E": "Errors",
        "DP": "Double plays",
        "CS": "Caught stealing",
        "SB": "Stolen bases allowed"
      },
      "basketball": {
        "team": {
          "Free throws": "Free throws",
          "2 pointers": "2 pointers",
          "3 pointers": "3 pointers",
          "Field goals": "Field goals",
          "Rebounds": "Rebounds",
          "Defensive rebounds": "Defensive rebounds",
          "Offensive rebounds": "Offensive rebounds",
          "Assists": "Assists",
          "Turnovers": "Turnovers",
          "Steals": "Steals",
          "Blocks": "Blocks",
          "Fouls": "Fouls",
          "Max points in a row": "Max points in a row",
          "Time spent in lead": "Time spent in lead",
          "Biggest lead": "Biggest lead"
        },
        "player": {
          "MIN": "Minutes played",
          "PTS": "Points",
          "REB": "Rebounds",
          "AST": "Assists",
          "STL": "Steals",
          "BLK": "Blocks",
          "PF": "Personal fouls",
          "TOV": "Turnovers",
          "OREB": "Offensive rebounds",
          "DREB": "Defensive rebounds",
          "FG": "Field goals",
          "FG%": "Field goals %",
          "FT": "Free throws",
          "FT%": "Free throws %",
          "3P": "3 pointers",
          "3P%": "3 pointers percentage",
          "+/-": "Plus-Minus",
          "PIR": "Performance Index Rating"
        }
      },
      "americanFootball": {
        "team": {
          "Offense": "Offense",
          "TD": "Touchdowns",
          "FG": "Field goals",
          "NET YDS": "Total yards",
          "TO": "Turnovers",
          "RZ%": "Red zone efficiency",
          "1D": "First downs",
          "3D%": "Third down efficiency",
          "Passing": "Passing",
          "PASS YDS": "Net passing yards",
          "PASS TD": "Passing touchdowns",
          "INT THROWN": "Interceptions thrown",
          "PASS YDS/ATT": "Average passing yards per attempt",
          "PASS RZ ATT": "Red zone passing attempts",
          "Rushing": "Rushing",
          "RUSH ATT": "Rushing attempts",
          "RUSH YDS": "Rushing yards",
          "RUSH YDS/ATT": "Average rushing yards per attempt",
          "Rushing 1st downs": "Rushing 1st downs",
          "RUSH RZ ATT": "Red zone rushing attempts",
          "Other": "Other",
          "FUML": "Fumbles lost"
        },
        "player": {
          "PASS COMP": "Completions",
          "PASS ATT": "Attempts",
          "PASS YDS": "Passing yards",
          "PASS TD": "Passing touchdowns",
          "INT": "Passing interceptions",
          "PASS YDS/ATT": "Passing yards per attempt",
          "PASS RTG": "Passer rating",
          "RUSH ATT": "Rushing attempts",
          "RUSH YDS": "Rushing yards",
          "RUSH TD": "Rushing touchdowns",
          "RUSH YDS/ATT": "Rushing yards per attempt",
          "RUSH LONG": "Longest rush",
          "REC TGT": "Receiving targets",
          "REC": "Receptions",
          "REC YDS": "Receiving yards",
          "REC TD": "Receiving touchdowns",
          "REC YDS/REC": "Yards per reception",
          "TCK": "Combined tackles",
          "SK": "Sacks",
          "FUML": "Fumbles lost",
          "FGM": "Field goals made",
          "XPM": "Extra points made",
          "PTS": "Total points"
        }
      },
      "rugby": {
        "team": {
          "Ball possession": "Ball possession",
          "Passes": "Passes",
          "Tries": "Tries",
          "Try assists": "Try assists",
          "Conversions": "Conversions",
          "Carries": "Carries",
          "Clean breaks": "Clean breaks",
          "Penalty goals": "Penalty goals",
          "Drop goals": "Drop goals",
          "Scrums": "Scrums",
          "Lineouts": "Lineouts",
          "Turnovers": "Turnovers",
          "Turnovers won": "Turnovers won",
          "Meters run": "Meters run",
          "Offloads": "Offloads",
          "Tackles": "Tackles",
          "Tackles missed": "Tackles missed",
          "Penalties conceded": "Penalties conceded",
          "Red cards": "Red cards",
          "Yellow cards": "Yellow cards"
        },
        "player": {
          "PTS": "Points",
          "TRY": "Tries",
          "TKL": "Tackles",
          "PG": "Penalty goals",
          "PAS": "Passes",
          "CAR": "Carries",
          "CB": "Clean breaks",
          "DG": "Drop goals",
          "MR": "Meters run",
          "OFF": "Offloads",
          "TM": "Tackles missed",
          "TA": "Try assists",
          "TW": "Turnovers won"
        }
      }
    },
    positions: {
      goalies: "Goalies",
      skaters: "Skaters",
      pitchers: "Pitchers",
      hitters: "Hitters",
      forwards: "Forwards",
      midfielders: "Midfielders",
      defenders: "Defenders",
      outfielders: "Outfielders",
      players: "Players",
    },
    filters: {
      titles: {
        lineType: "Line Type",
        game: "Game",
        outcome: "O/U",
        betType: "Bet Type",
        trendType: "Trend Type",
        signals: "Signals",
        season: "Season",
        team: "Team",
        minOdds: "Min Odds",
        timeframe: "Timeframe",
      },
      plurals: {
        lineType: "Line Types",
        game: "Games",
        outcome: "Outcomes",
        betType: "Bet Types",
        trendType: "Trend Types",
        signals: "Signals",
        season: "Seasons",
        team: "Teams",
      },
      options: {
        game: {
          all: "All Games",
          byGame: "By Game",
        },
        team: {
          all: "All Teams",
        },
        lineType: {
          main: "Main Lines",
          alternate: "Alternate Lines",
        },
        outcome: {
          all: "Over+Under",
          over: "Over",
          under: "Under",
          yes: "Yes",
          no: "No",
          cover: "Cover",
        },
        betType: {
          all: "All Bet Types",
        },
        minOdds: {
          all: "All Odds",
        },
        timeframe: {
          season: "Season",
          playoffs: "Playoffs",
          headToHead: "Head to Head",
          last5: "Last 5",
          last10: "Last 10",
          last20: "Last 20",
          last30: "Last 30",
        },
        splits: {
          all: "Home+Away",
          home: "Home",
          away: "Away",
        },
        trendType: {
          player: "Player",
          team: "Team",
        },
        qualifier: {
          cumulativeStats: "Total",
        },
        signals: {
          allSignals: "All Signals",
          recentForm: "Recent Form",
          headToHead: "Head to Head",
          homeAwaySplits: "Home/Away Splits",
          opponentRank: "Opponent Rank",
          injuryImpact: "Injury Impact",
          starter: "Starter",
          weather: "Weather",
          startingPitcher: "Starting Pitcher",
        },
      },
    },
    empty: {
      checkBackLater: "Please check back later.",
      pendingOdds: {
        title: "Pending Odds",
      },
    },
  },
  betTypes: {
    ANYTIME_GOAL_SCORER: "Goals",
    ANYTIME_TOUCHDOWN: "Anytime TD",
    ANYTIME_TOUCHDOWN_1Q: "1Q Anytime TD",
    ANYTIME_TRY_SCORER: "Anytime Try Scorer",
    ASSISTS: "Assists",
    ASSISTS_1Q: "1Q Assists",
    ASSISTS_PLUS_REBOUNDS: "REB+AST",
    BLOCKED_SHOTS: "Blocked Shots",
    BLOCKS: "Blocks",
    BOTH_TEAMS_TO_SCORE: "Both Teams To Score",
    CARDS: "Cards",
    CORNERS: "Team Corners",
    DISPOSALS: "Disposals",
    DOUBLE_CHANCE: "Double Chance",
    DOUBLE_DOUBLE: "Double Double",
    EXTRA_POINTS_MADE: "XP Made",
    FIELD_GOALS_MADE: "FG Made",
    GAME_TOTAL: "Game Total",
    GAME_TOTAL_1H: "1H Game Total",
    GAME_TOTAL_1Q: "1Q Game Total",
    GAME_TOTAL_2H: "2H Game Total",
    GAME_TOTAL_CARDS: "Game Total Cards",
    GAME_TOTAL_FIRST_5_INNINGS: "First 5 Innings Game Total",
    GOAL_OR_ASSIST: "G or AST",
    GOALS: "Goals",
    GOALS_ALLOWED: "Goals Against",
    HITTER_DOUBLES: "Doubles",
    HITTER_HITS: "Hits",
    HITTER_HITS_PLUS_RUNS_PLUS_RUNS_BATTED_IN: "H+R+RBI",
    HITTER_HOME_RUNS: "HR",
    HITTER_RUNS: "Runs",
    HITTER_RUNS_BATTED_IN: "RBI",
    HITTER_SINGLES: "Singles",
    HITTER_STOLEN_BASES: "Stolen Bases",
    HITTER_TOTAL_BASES: "Total Bases",
    HITTER_TRIPLES: "Triples",
    INTERCEPTIONS: "Int",
    KICKING_POINTS: "Kicking Points",
    MARKS: "Marks",
    MONEY_LINE: "Moneyline",
    MONEY_LINE_1H: "1H Moneyline",
    MONEY_LINE_1Q: "1Q Moneyline",
    MONEY_LINE_2H: "2H Moneyline",
    MONEY_LINE_FIRST_5_INNINGS: "First 5 Innings Moneyline",
    PASSING_ATTEMPTS: "Pass Att",
    PASSING_COMPLETIONS: "Pass Compl",
    PASSING_PLUS_RUSHING_YARDS: "Pass + Rush Yards",
    PASSING_PLUS_RUSHING_YARDS_1Q: "1Q Pass + Rush Yards",
    PASSING_TOUCHDOWNS: "Pass TD",
    PASSING_YARDS: "Pass Yards",
    PASSING_YARDS_1Q: "1Q Pass Yards",
    PITCHER_EARNED_RUNS: "Earned Runs",
    PITCHER_HITS_ALLOWED: "Hits Allowed",
    PITCHER_OUTS: "Pitcher Outs",
    PITCHER_STRIKEOUTS: "Strikeouts",
    PITCHER_WALKS_ALLOWED: "Walks Allowed",
    POINTS: "Points",
    POINTS_1Q: "1Q Points",
    POINTS_PLUS_ASSISTS: "PTS+AST",
    POINTS_PLUS_ASSISTS_PLUS_REBOUNDS: "PTS+AST+REB",
    POINTS_PLUS_REBOUNDS: "PTS+REB",
    POWERPLAY_POINTS: "Powerplay Pts",
    REBOUNDS: "Rebounds",
    REBOUNDS_1Q: "1Q Rebounds",
    RECEIVING_YARDS: "Rec Yards",
    RECEIVING_YARDS_1Q: "1Q Rec Yards",
    RECEPTIONS: "Receptions",
    RUN_FIRST_INNING: "Run First Inning",
    RUSHING_ATTEMPTS: "Rush Att",
    RUSHING_PLUS_RECEIVING_YARDS: "Rush + Rec Yards",
    RUSHING_PLUS_RECEIVING_YARDS_1Q: "1Q Rush + Rec Yards",
    RUSHING_YARDS: "Rush Yards",
    RUSHING_YARDS_1Q: "1Q Rush Yards",
    SAVES: "Saves",
    SHOTS: "SHO",
    SHOTS_ON_GOAL: "Shots on Goal",
    SHOTS_ON_TARGET: "Shots on Target",
    player: {
      SHOTS_ON_TARGET: "Shots on Target",
    },
    team: {
      SHOTS_ON_TARGET: "Team Shots on Target",
    },
    SHUTOUT: "Shutout",
    SPREAD: "Spread",
    SPREAD_1H: "1H Spread",
    SPREAD_1Q: "1Q Spread",
    SPREAD_2H: "2H Spread",
    SPREAD_FIRST_5_INNINGS: "First 5 Innings Spread",
    STEALS: "Steals",
    STEALS_PLUS_BLOCKS: "STL+BLK",
    TACKLES: "Tackles",
    TEAM_TOTAL: "Team Total",
    TEAM_TOTAL_1H: "1H Team Total",
    TEAM_TOTAL_1Q: "1Q Team Total",
    TEAM_TOTAL_2H: "2H Team Total",
    TEAM_TOTAL_CARDS: "Team Total Cards",
    THREE_POINTS_MADE: "3PTM",
    TRIES: "Tries",
    TRIPLE_DOUBLE: "Triple Double",
    TURNOVERS: "Turnovers",
    WIN_TO_NIL: "Win To Nil",
  },
};
